module.exports = __webpack_public_path__ + "static/media/login-retreive.9532de3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-retreive.png
// module id = 734
// module chunks = 110